import PostList from "./PostList.presenter";
export default PostList;
